module.exports = __webpack_public_path__ + "static/media/39.6fadc9ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/39.png
// module id = 543
// module chunks = 0